module.exports = __webpack_public_path__ + "static/media/03-Leipzig@3x.60b79a20.jpg";